import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss(event) {
    this.element.remove()
  }
}
